import React from 'react';
import Toast from '@applane/react-toast';
import ReactTooltip from 'react-tooltip';
import moment from 'moment';
import {
  Table, Text, TouchableOpacity, View,
} from '../../../app-components';
import { dealersListUri, subDealersListUri } from '../../../Queries/dealer';
import { ROUTES } from '../../../Lib/constants';
import vars from '../../../theme/vars';
import { modifyDateView, shorten } from '../../../Lib/helpers';
import { invoke } from '../../../AppServices';

const { headings } = vars;

const checkExpiryWithBGColor = (value) => {
  const res = { backgroundColor: '', text: '' };

  const expiryDate = moment(value);
  // const today = moment().utc();
  // const difference = expiryDate.diff(today, 'days');

  if (expiryDate.format('YYYY') === '1970' || value === 'N.A.') {
    res.backgroundColor = '#8abcb1';
    res.text = 'N.A.';
  } else {
    // if (difference > 0)
    res.backgroundColor = '#2cbcb1';
    res.text = expiryDate.format('MMM DD, YYYY');
  }
  // else if (difference < 0) {
  //   res.backgroundColor = 'red';
  //   res.text = 'Expired';
  // } else {
  //   res.backgroundColor = 'orange';
  //   res.text = 'Expiring Today';
  // }
  return res;
};


const tableItems = {
  lg: {
    columns: [
      {
        header: 'Dealership Name',
        type: 'text',
        width: 300,
        render: ({ item }) => (
          <Text
            style={{
              fontSize: 16,
              fontFamily: 'Mulish-Medium',
            }}
          >
            {shorten(item?.name, 30)}
          </Text>
        ),
      },
      {
        header: 'Phone #',
        type: 'text',
        field: 'phonenumber',
        width: 200,

      },
      {
        header: 'Email Id',
        type: 'text',
        width: 300,

        render: ({ item }) => (
          <Text
            style={{
              fontSize: 16,
              fontFamily: 'Mulish-Medium',
            }}
          >
            {shorten(item?.email, 30)}
          </Text>
        ),
      },
      {
        header: 'Status',
        type: 'text',
        width: 200,

        render: ({ item }) =>
          // const res = checkExpiryWithBGColor(item?.expire);
          // eslint-disable-next-line implicit-arrow-linebreak
          (
            <>
              <ReactTooltip
                place="bottom"
                type="dark"
                effect="float"
                id={item._id}
              />
              <div data-tip="" data-for={item._id}>
                <TouchableOpacity
                  style={{
                    width: 100,
                    borderRadius: 15,
                    backgroundColor:
                      // res.text !== 'Expired' &&
                      item?.activityStatus === 'Active' ? '#2cbcb1' : '#009dcc',
                    alignItems: 'center',
                    paddingTop: 5,
                    paddingBottom: 5,
                  }}
                >
                  <Text style={{ ...headings.h8, color: '#FFF' }}>
                    {/* {res.text === 'Expired' ? 'Inactive' : item?.activityStatus} */}
                    {item?.activityStatus}
                  </Text>
                </TouchableOpacity>
              </div>
            </>
          )
        ,
      },
      {
        header: 'Last UCI',
        type: 'date',
        width: 200,
        field: 'lastUCI',
        render: ({ item }) => {
          const res = checkExpiryWithBGColor(item?.lastUCI);
          return (
            <View
              style={{
                width: 150,
                borderRadius: 15,
                backgroundColor:
                // res.text !== 'Expired' &&
                item?.activityStatus === 'Active' ? '#2cbcb1' : '#009dcc',                
                alignItems: 'center',
                paddingTop: 5,
                paddingBottom: 5,
              }}
            >
              <Text style={{ ...headings.h8, color: '#FFF' }}>{item?.activityStatus !== 'Active' ? 'Inactive' : !item.lastUCI ? 'Not Update' : modifyDateView(item.lastUCI)}</Text>
            </View>
          );
        },
      },
      {
        header: 'Last RO',
        type: 'date',
        width: 200,
        field: 'lastRO',
        render: ({ item }) => {
          const res = checkExpiryWithBGColor(item?.lastRO);
          return (
            <View
              style={{
                width: 150,
                borderRadius: 15,
                backgroundColor:
                // res.text !== 'Expired' &&
                item?.activityStatus === 'Active' ? '#2cbcb1' : '#009dcc',                
                alignItems: 'center',
                paddingTop: 5,
                paddingBottom: 5,
              }}
            >
              <Text style={{ ...headings.h8, color: '#FFF' }}>{item?.activityStatus !== 'Active' ? 'Inactive' : !item.lastRO  ? 'Not Update' : modifyDateView(item.lastRO)}</Text>
            </View>
          );
        },
      },
    ],
  },
};

export default Table({
  reloadEvent: ROUTES.superDealerData.name,
  uri: subDealersListUri,
  ...tableItems,
  action: ({ item }) => ({
    type: 'link',
    link: {
      view: ROUTES.ViewSubDealer.name,
      params: { item: { ...item }, editable: false },
    },
  }),
});
